(() => {
  function setup() {
    document.querySelectorAll('[data-options-mobile-buy]').forEach(bar => {
      if (bar.dataset.initialized) return;
      const section = document.getElementById('MainProduct-' + bar.dataset.sectionId);
      if (!section) return;
      const findButton = () => section.querySelector('product-form button[name="add"]');
      const original = findButton();
      if (!original) return;
      bar.dataset.initialized = 'true';
      const button = bar.querySelector('[data-options-mobile-button]');
      const updateClearance = () => {
        const mobile = window.matchMedia('(max-width:749px)').matches;
        const height = mobile && !bar.hidden ? Math.ceil(bar.getBoundingClientRect().height) + 12 : 0;
        document.documentElement.style.setProperty('--options-buy-clearance', height + 'px');
      };
      new ResizeObserver(updateClearance).observe(bar);
      window.addEventListener('resize', updateClearance);
      const sync = () => {
        const current = findButton();
        if (!current) { bar.hidden = true; updateClearance(); return; }
        button.disabled = current.disabled;
        button.textContent = current.disabled ? current.textContent.trim() :
          (bar.dataset.chooseOptions === 'true' ? 'Choose options' : 'Add to cart');
      };
      new MutationObserver(sync).observe(section, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled']});
      new IntersectionObserver(entries => {
        bar.hidden = entries[0].isIntersecting;
        updateClearance();
      }).observe(original);
      button.addEventListener('click', () => {
        const current = findButton();
        if (!current || current.disabled) return;
        if (bar.dataset.chooseOptions === 'true') {
          const picker = section.querySelector('variant-selects') || current;
          picker.scrollIntoView({behavior:'smooth', block:'center'});
          const control = picker.querySelector('input:not([disabled]), select, button') || current;
          control.focus({preventScroll:true});
        } else {
          current.click();
        }
      });
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
})();
